import i18n from "@/i18n";
import ExcelJS from "exceljs";
import excelSupporter from "@/excelSupporter.js";

const list = {
  // =================================================================================================================
  components() {
    return [
      {
        'component': 'search-start-end',
        label: '작성일',
        value: 'date',
        query: {'ss': 'startDate', 'ee': 'endDate'},
        options: {
          default: {sd: '', ed: ''},
        }
      },
      {
        'component': 'search-column-keyword',
        label: '검색조건',
        value: 'column',
        query: {'ck_t': 'head', 'ck_k': 'keyword'},
        options: {hiddenList: ['작성일', '근로자수']}
      },
    ]
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    //  검색일
    if (search.date) {
      conditions.push({key: 'created_at', operator: '>=', value: search.date.startDate})
      conditions.push({key: 'created_at', operator: '<', value: search.date.endDate ? new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd") : ''})
    }

    //  검색조건
    const heads = list.getHead().map(e => {return {[e.name] : e.key}});
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({key: types[search.column.head], operator: 'LIKE', value: `%${search.column.keyword}%`})
    }
    return conditions;
  },


  // =================================================================================================================
  getHead: () => {
    return [
      {
        "name": "회사명",
        "key": "body.stdInfo.field_name"
      },
      {
        "name": "작업(공정)",
        "key": "body.작업공정"
      },
      {
        "name": "근로자수",
        "key": "body.근로자수"
      },
      {
        "name": "소속명",
        "key": "body.stdInfo.department"
      },
      {
        "name": "부서명",
        "key": "body.stdInfo.com_name"
      },
      {
        "name": "작성자",
        "key": "body.stdInfo.writer_name"
      },
      {
        "name": "작성일",
        "key": "created_at"
      },
    ]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0:
          return func.getContent(value).stdInfo.field_name // 회사명
        case 1:
          return func.getContent(value).작업공정 // 교육일
        case 2:
          return func.getContent(value).근로자수 // 교육장소
        case 3:
          return func.getContent(value).stdInfo.department // 소속명
        case 4:
          return func.getContent(value).stdInfo.section // 부서명
        case 5:
          return func.getContent(value).stdInfo.writer_name // 작성자
        case 6:
          return func.getCreatedDate(value.created_at); // 작성일
      }
    } catch (e) { /*ignore*/ }
    return ''
  },

  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},

  // =================================================================================================================
  // 엑셀 다운로드 설정 (목록형 단일 시트 - 템플릿 파일 없이 코드에서 직접 생성)
  //  - 1행 헤더, 2행부터 채운다. 안전보건정보조사결과(공정>기계기구 2단 중첩)를 "기계기구 1건당 1행"으로 펼친다.
  //  - 문서 단위 정보(구분/부서/작성자/근로자수/혼재작업정보/특이사항유무/도급유무)는 각 문서의 첫 행에만 표기한다.
  //  컬럼: A 구분(빈값) / B 부서(com_name) / C 작성자 / D 근로자 수 /
  //        E 공정(작업)순서 / F 기계기구 설비명 / G 수량 /
  //        H 혼재작업의 위험성 및 작업상황 등에 관한 정보 / I 근로자 건강진단 결과 특이사항 유무 / J 도급 유무
  excelInfo: (dataList) => {
    const HEADER = [
      "구분", "부서", "작성자", "근로자 수", "공정(작업)순서", "기계기구 설비명", "수량",
      "혼재작업의 위험성 및 작업상황 등에 관한 정보", "근로자 건강진단(건강검진)결과 특이사항 유무", "도급 유무",
    ];

    // 혼재작업(작업상황정보) 테이블을 한 셀 텍스트로 요약
    const summarizeMixedWork = (arr) => {
      if (!Array.isArray(arr)) return "";
      return arr
        .map((w) => {
          const nm = w && w.작업명 ? w.작업명 : "";
          const period = w && (w.시작일 || w.종료일) ? ` (${w.시작일 || ""}~${w.종료일 || ""})` : "";
          const detail = w && w.혼재작업 ? `: ${w.혼재작업}` : "";
          return `${nm}${period}${detail}`.trim();
        })
        .filter((s) => s !== "")
        .join("\n");
    };

    return {
      downloadFileName: "안전보건 정보조사 결과",
      worksheetName: () => "안전보건 정보조사 결과",
      singleSheet: (worksheet, posts) => {
        // 헤더 (1행)
        HEADER.forEach((h, ci) => {
          worksheet.getRow(1).getCell(ci + 1).value = h;
        });

        // 데이터 (2행부터)
        let rowIdx = 2;
        posts.forEach((post) => {
          let body = {};
          try {
            body = JSON.parse(post.post_content).body || {};
          } catch (e) { /* ignore */ }
          const std = body.stdInfo || {};

          // 문서 단위 값
          const 부서 = std.com_name || "";
          const 작성자 = std.writer_name || "";
          const 근로자수 = body.근로자수 || "";
          const 혼재작업정보 = summarizeMixedWork(body.작업상황정보);
          const 특이사항유무 = body.특이사항유무 || "";
          const 도급유무 = body.도급유무 || "";

          // 공정(그룹) > 기계기구(항목) 2단 중첩을 항목 단위 행으로 펼친다.
          const groups = Array.isArray(body.안전보건정보조사결과) ? body.안전보건정보조사결과 : [];
          const itemRows = [];
          groups.forEach((g) => {
            const items = g && Array.isArray(g.items) ? g.items : [];
            const 공정명 = g && g.공정명 ? g.공정명 : "";
            if (items.length === 0) {
              itemRows.push({ 공정명, 기계기구설비명: "", 수량: "" });
            } else {
              items.forEach((it) => {
                itemRows.push({
                  공정명,
                  기계기구설비명: it && it.기계기구설비명 ? it.기계기구설비명 : "",
                  수량: it && (it.수량 || it.수량 === 0) ? it.수량 : "",
                });
              });
            }
          });
          // 조사결과가 없는 문서도 한 줄로 표기한다.
          if (itemRows.length === 0) itemRows.push({ 공정명: "", 기계기구설비명: "", 수량: "" });

          itemRows.forEach((ir, idx) => {
            const row = worksheet.getRow(rowIdx++);
            if (idx === 0) {
              // 문서 단위 정보는 첫 행에만
              row.getCell(1).value = ""; // A 구분 (빈값)
              row.getCell(2).value = 부서; // B 부서
              row.getCell(3).value = 작성자; // C 작성자
              row.getCell(4).value = 근로자수; // D 근로자 수
              row.getCell(8).value = 혼재작업정보; // H 혼재작업 정보
              row.getCell(9).value = 특이사항유무; // I 특이사항 유무
              row.getCell(10).value = 도급유무; // J 도급 유무
            }
            row.getCell(5).value = ir.공정명; // E 공정(작업)순서
            row.getCell(6).value = ir.기계기구설비명; // F 기계기구 설비명
            row.getCell(7).value = ir.수량; // G 수량
          });
        });
      },
    };
  },

  // 전체 다운로드(모든 문서 엑셀다운로드) - 새 워크북에 목록형으로 채운 뒤 다운로드
  customExcelDownload: async (dataList, title) => {
    const excelInfo = list.excelInfo(dataList);
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(excelInfo.worksheetName ? excelInfo.worksheetName() : "Sheet1");
    excelInfo.singleSheet(worksheet, dataList);
    await excelSupporter.workbookDownload(workbook, excelInfo.downloadFileName);
  },
}

export default list;
